import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { connect } from 'redaction'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'

import HeaderSubNavItem from './HeaderSubNavItem/HeaderSubNavItem'

import s from './ExceptMobile.scss'


class HeaderSubNavExceptMobile extends Component {

  static propTypes = {
    nav: PropTypes.arrayOf(PropTypes.object),
    gender: PropTypes.string,
    isDesktopDropdownEnabled: PropTypes.bool,
    navigationIsFetched: PropTypes.bool,
  }

  static defaultProps = {
    nav: [],
  }

  componentDidMount() {
    const { gender, isDesktopDropdownEnabled, navigationIsFetched } = this.props

    // Don't refetch after layout changing
    if (isDesktopDropdownEnabled && !navigationIsFetched) {
      actions.view.navigation.fetch(gender)
    }
  }

  componentDidUpdate({ gender: prevGender, isDesktopDropdownEnabled: prevIsDesktopDropdownEnabled }) {
    const { isDesktopDropdownEnabled, gender, navigationIsFetched } = this.props

    const needToFetchNavigation = isDesktopDropdownEnabled && (
      isDesktopDropdownEnabled !== prevIsDesktopDropdownEnabled && !navigationIsFetched
      || prevGender !== gender
    )

    if (needToFetchNavigation) {
      actions.view.navigation.fetch(gender)
    }
  }

  render() {
    const { nav, isDesktopDropdownEnabled } = this.props

    return (
      <div className={s.navContainer}>
        <WidthContainer>
          <div className={s.nav} data-testid={constants.testIds.layout.headerNav} role="menubar">
            {
              nav.map(({ isBig, ...rest }, index) => (
                <HeaderSubNavItem
                  key={index}
                  isDesktopDropdownEnabled={isDesktopDropdownEnabled}
                  isBig={isBig}
                  {...rest}
                />
              ))
            }
          </div>
        </WidthContainer>
      </div>
    )
  }
}


export default connect({
  navigationIsFetched: 'view.navigation.isFetched',
})(HeaderSubNavExceptMobile)
